import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import SchoolIcon from "@mui/icons-material/School";

const typeConfig = {
  tip: { icon: <TipsAndUpdatesIcon sx={{ fontSize: 16, color: "#22c55e" }} />, color: "#166534" },
  improvement: { icon: <SchoolIcon sx={{ fontSize: 16, color: "#3b82f6" }} />, color: "#1e40af" },
  warning: { icon: <LightbulbIcon sx={{ fontSize: 16, color: "#f59e0b" }} />, color: "#92400e" },
};

export default function TipsWidget({ tips }) {
  if (!tips || tips.length === 0) return null;

  return (
    <Paper className="glass-card" sx={{ p: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
        <LightbulbIcon sx={{ color: "#f59e0b", fontSize: 22 }} />
        <Typography fontWeight={700} fontSize={15} color="#1e293b">
          Tips & Best Practices
        </Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {tips.map((tip, i) => {
          const config = typeConfig[tip.type] || typeConfig.tip;
          return (
            <Box key={i} sx={{
              display: "flex", alignItems: "flex-start", gap: 1.5, p: 1.5,
              borderRadius: 2, bgcolor: "rgba(255,255,255,0.6)", border: "1px solid #e2e8f0",
            }}>
              {config.icon}
              <Typography variant="body2" color={config.color} fontWeight={500} fontSize={13}>
                {tip.text}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Paper>
  );
}
